<template>
  <div>
    <v-app-bar
      color="primary"
      dark
    >
      <v-btn
        icon
        :disabled="!prevPage"
        @click="$router.push(prevPage)"
      >
        <v-icon
          v-if="prevPage"
        >
          keyboard_arrow_left
        </v-icon>

        <v-icon
          v-else
        >
          account_circle
        </v-icon>
      </v-btn>

      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu
        v-if="showDropDown"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn
            dark
            icon
            v-on="on"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list
          dense
        >
          <v-list-item
            @click="onLogout"
          >
            <v-list-item-title>
              Kirjaudu ulos
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    prevPage: {
      type: String,
      default: null,
    },
    showDropDown: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    ...mapActions({
      logout: 'currentUser/logout',
    }),

    async onLogout() {
      await this.logout();
      await this.$router.replace('/kirjaudu');
    },
  },
};
</script>
